import { useContext, FC } from 'react';
import { context as StateContext } from '../context/state';
import _SignedInScreen from '../screen/SignedInScreen';

type Props = {
  className?: string;
};

const SignedInScreen: FC<Props> = ({ className }) => {
  const state = useContext(StateContext);

  return !state.fatalError && state.authentication.fetching === 0 && state.authentication.signedInUser ? (
    <_SignedInScreen className={className} />
  ) : null;
};

export default SignedInScreen;
